import { useState, useEffect } from "react";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Collabs from "./pages/Collabs";
import Tarefas from "./pages/Tarefas";
import Sala from "./pages/Sala";
import Implantacao from "./pages/Implantacao";

function usePortalAuth() {
  const [usuario, setUsuario] = useState(null);
  const [pronto, setPronto] = useState(false);

  useEffect(() => {
    try {
      const salvo = localStorage.getItem("portal_cliente_usuario");
      if (salvo) setUsuario(JSON.parse(salvo));
    } catch {}
    setPronto(true);
  }, []);

  const login = (u) => {
    localStorage.setItem("portal_cliente_usuario", JSON.stringify(u));
    setUsuario(u);
  };
  const logout = () => {
    localStorage.removeItem("portal_cliente_usuario");
    setUsuario(null);
  };
  return { usuario, login, logout, pronto };
}

export default function App() {
  const { usuario, login, logout, pronto } = usePortalAuth();
  const [pagina, setPagina] = useState("dashboard");
  const [salaParams, setSalaParams] = useState(null);

  // Detecta rota /sala/[chamada_id] na URL
  useEffect(() => {
    const path = window.location.pathname;
    const match = path.match(/^\/sala\/(.+)$/);
    if (match) {
      setSalaParams({ chamadaId: match[1] });
      setPagina("sala");
    }
  }, []);

  // Aguarda verificação do localStorage
  if (!pronto) return (
    <div style={{ minHeight: "100vh", background: "#0f172a", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div style={{ color: "#64748b", fontSize: "14px" }}>⏳ Carregando...</div>
    </div>
  );

  if (!usuario) return <Login onLogin={login} />;

  if (pagina === "sala" && salaParams) {
    return <Sala chamadaId={salaParams.chamadaId} usuario={usuario} onSair={() => { setSalaParams(null); setPagina("collabs"); }} />;
  }

  return (
    <div style={{ minHeight: "100vh", background: "#0f172a", display: "flex", flexDirection: "column" }}>
      {/* Header */}
      <header style={{ background: "#1e293b", borderBottom: "1px solid #334155", padding: "0 24px", height: "64px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <img src="https://media.base44.com/images/public/692ce8b41b53f8d1d71b7ec7/a124921b8_693263386.jpg" alt="Logo" style={{ height: "36px", borderRadius: "8px" }} onError={e => e.target.style.display = "none"} />
          <div>
            <div style={{ fontWeight: "700", fontSize: "15px", color: "#f1f5f9" }}>Portal Cliente</div>
            <div style={{ fontSize: "11px", color: "#64748b" }}>IntegraConnect</div>
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
          <span style={{ fontSize: "13px", color: "#94a3b8" }}>Olá, <strong style={{ color: "#e2e8f0" }}>{usuario.nome}</strong></span>
          <button onClick={logout} style={{ background: "transparent", border: "1px solid #475569", color: "#94a3b8", padding: "6px 14px", borderRadius: "8px", cursor: "pointer", fontSize: "13px" }}>Sair</button>
        </div>
      </header>

      {/* Nav */}
      <nav style={{ background: "#1e293b", borderBottom: "1px solid #1e293b", padding: "0 24px", display: "flex", gap: "4px" }}>
        {[
          { id: "dashboard", label: "📊 Dashboard" },
          { id: "collabs", label: "🤝 Collabs & Reuniões" },
          { id: "tarefas", label: "✅ Tarefas" },
          { id: "implantacao", label: "🚀 Implantação" },
        ].map(item => (
          <button key={item.id} onClick={() => setPagina(item.id)} style={{
            background: "transparent", border: "none", padding: "14px 18px", cursor: "pointer",
            fontSize: "13px", fontWeight: pagina === item.id ? "600" : "400",
            color: pagina === item.id ? "#0FC9C5" : "#94a3b8",
            borderBottom: pagina === item.id ? "2px solid #0FC9C5" : "2px solid transparent",
            transition: "all 0.2s"
          }}>{item.label}</button>
        ))}
      </nav>

      {/* Content */}
      <main style={{ flex: 1, padding: "24px", maxWidth: "1200px", width: "100%", margin: "0 auto" }}>
        {pagina === "dashboard" && <Dashboard usuario={usuario} onNavegar={setPagina} onEntrarSala={(id) => { setSalaParams({ chamadaId: id }); setPagina("sala"); }} />}
        {pagina === "collabs" && <Collabs usuario={usuario} onEntrarSala={(id) => { setSalaParams({ chamadaId: id }); setPagina("sala"); }} />}
        {pagina === "tarefas" && <Tarefas usuario={usuario} />}
        {pagina === "implantacao" && <Implantacao usuario={usuario} />}
      </main>
    </div>
  );
}
